"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var components_1 = require("./components");
Object.defineProperty(exports, "Accordion", { enumerable: true, get: function () { return components_1.Accordion; } });
//# sourceMappingURL=index.js.map